import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

export const useDeleteExercise = () => {
  const client = useApiClient();

  return useMutation<null, Error, { exerciseID: number }>({
    mutationFn: ({ exerciseID }) => client.deleteExercise(exerciseID),
  });
};
